import "pouchdb-browser";
import * as blobUtil from "blob-util";

import { assert } from "./utils";

const imagesSheet = new CSSStyleSheet();

const processedHashes: Set<string> = new Set();

document.adoptedStyleSheets.push(imagesSheet);

export interface Documentish {
  _id: PouchDB.Core.DocumentId;
  _rev: PouchDB.Core.RevisionId;
  _attachments?: PouchDB.Core.Attachments | undefined;
}

export function getImageClass(db: PouchDB.Database, doc: Documentish, attachmentName: string) : string|null {
  const attachmentData = doc._attachments?.[attachmentName];
  if (attachmentData == null || attachmentData.digest == null)
    return null;
  const digestFiltered = attachmentData.digest.replaceAll("=","").replaceAll("+", "-").replaceAll("/", "_");
  const className = `db-attachment-${digestFiltered}`;

  if (!processedHashes.has(attachmentData.digest)) {
    db.getAttachment(doc._id, attachmentName, {rev: doc._rev}).then((attachment) => {
      assert(attachment instanceof Blob);
      const newRule = `.${className} { --image: url("${blobUtil.createObjectURL(attachment)}"); }`;
      // console.log(newRule);
      imagesSheet.insertRule(newRule);
    }).catch((err) => console.log(err));
    processedHashes.add(attachmentData.digest);
  }
  
  return className;
}
